module.exports = __webpack_public_path__ + "img/banner03-desktop.76812524.webp";